import OfflineApp from './OfflineApp';

export default OfflineApp;
